import React, { lazy, Suspense } from 'react';

const LazySystemConfiguration = lazy(() => import('./SystemConfiguration'));

const SystemConfiguration = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode }
) => (
  <Suspense fallback={null}>
    <LazySystemConfiguration {...props} />
  </Suspense>
);

export default SystemConfiguration;
